const MAX_SCROLL_RESTORE_ATTEMPTS = 5;
const TRY_TO_SCROLL_INTERVAL_MS = 50;
let timeoutHandle = null;

export const scrollPosition = () => { return { x: window.scrollX, y: window.scrollY, attempts: 1 } }

export const withScrollPosition = (from) => {
  const scroll = scrollPosition();
  return { from: { ...from, state: { scroll } } };
}

export const restoreScrollPosition = (scrollTarget) => {
  if (!scrollTarget) return;

  clearTimeout(timeoutHandle);

  const body = document.body;
  const html = document.documentElement;

  // From http://stackoverflow.com/a/1147768
  const documentHeight = Math.max(body.scrollHeight, body.offsetHeight,
    html.clientHeight, html.scrollHeight, html.offsetHeight);

  if (documentHeight - window.innerHeight >= scrollTarget.y || scrollTarget.attempts > MAX_SCROLL_RESTORE_ATTEMPTS) {
    window.scrollTo(scrollTarget.x, scrollTarget.y);
  } else {
    scrollTarget.attempts++;
    timeoutHandle = setTimeout(() => restoreScrollPosition(scrollTarget), TRY_TO_SCROLL_INTERVAL_MS);
  }
};
